export default __webpack_public_path__ + "static/google_playstore-0777c6cd255b9c75c9d2354028c88714.svg";